'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonCircle = undefined;

var _systemComponents = require('system-components');

var _systemComponents2 = _interopRequireDefault(_systemComponents);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonCircle = exports.ButtonCircle = (0, _systemComponents2.default)({
  is: _Button2.default,
  px: 3,
  borderRadius: 9999
});

ButtonCircle.displayName = 'ButtonCircle';

exports.default = ButtonCircle;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/ButtonCircle.js
// module id = 485
// module chunks = 168707334958949